const endpoint = "https://api.getchill.ai/mcp";

export function McpDocs() {
  return <main style={{ maxWidth: 760, margin: "64px auto", padding: "0 24px", fontFamily: "ui-sans-serif, system-ui", lineHeight: 1.55 }}>
    <p>Chill Docs</p><h1>Model Context Protocol</h1>
    <p>Connect an agent to your Chill account. OAuth opens Chill to approve access; your agent never receives a password or payment details.</p>
    <h2>Codex</h2><pre>codex mcp add chill --url {endpoint}{"\n"}codex mcp login chill</pre>
    <h2>Claude Code</h2><pre>claude mcp add --transport http chill {endpoint}{"\n"}claude mcp login chill</pre>
    <h2>Verify</h2><p>Ask the connected agent: <code>Use Chill to verify my connection.</code></p>
    <h2>Available now</h2><ul><li>Verify the authorized account</li><li>List account-owned domains</li><li>Inspect a domain</li><li>Check domain availability and receive a ten-minute quote</li><li>Buy a quoted domain with your saved card</li></ul>
    <p>Domain registration requires your explicit price confirmation and a saved payment card. Any plan qualifies; annual billing is not required.</p>
  </main>;
}
